export default "__VITE_ASSET__D16t3F$w__"